import { type FileUploadController, ImageUpload } from "@msuite/ui/file-upload";
import { useTranslation } from "@msuite/ui/localization";
import { useWorkspaceMediaDefault } from "./use-workspace-media-defaults";

/** Props Interface */
export interface WorkspaceFormImagesProps {
	workspaceLogoFileController: FileUploadController;
	workspaceLetterpaperFileController: FileUploadController;
	workspaceId: string | null;
}

export function WorkspaceFormImages({
	workspaceLogoFileController,
	workspaceLetterpaperFileController,
	workspaceId,
}: WorkspaceFormImagesProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { workspaceLogoUrl, workspaceLetterpaperUrl } = useWorkspaceMediaDefault(workspaceId);

	/** Render */
	return (
		<div className="v-stack gap-6">
			<div className="v-stack">
				<p className="label cursor-default">{t("organization.workspace_logo")}</p>
				<ImageUpload
					key={workspaceLogoUrl}
					type="image"
					renderFile={() => null}
					// TODO: Implement file removal
					controller={workspaceLogoFileController}
					defaultImageUrl={workspaceLogoUrl || undefined}
					data-cy="workspace-logo-upload"
				/>
			</div>
			<div className="v-stack">
				<p className="label">{t("organization.workspace_letterpaper")}</p>
				<ImageUpload
					key={workspaceLetterpaperUrl}
					type="image"
					renderFile={() => null}
					// TODO: Implement file removal
					controller={workspaceLetterpaperFileController}
					defaultImageUrl={workspaceLetterpaperUrl || undefined}
				/>
			</div>
		</div>
	);
}
